import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ALL_MY_SURVEYS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AllListMySurveyDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadListMySurvey =
  (
    user_id: string | number,
  ): ThunkAction<Promise<void>, State, null, AllListMySurveyDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: ALL_MY_SURVEYS + REQUEST });
    try {
      const payload = await api.loadMySurveys(user_id);
      dispatch({ type: ALL_MY_SURVEYS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ALL_MY_SURVEYS + FAILURE, error });
    }
  };

export const allListMySurveyIdle = () => ({ type: ALL_MY_SURVEYS + IDLE });
